/* istanbul ignore file */
import React from 'react';
import { RelatedContractsList } from 'domain/people/contracts';

const EmployeeContractsList = () => {
  return <RelatedContractsList />;
};

export default EmployeeContractsList;
